/**
 * @Author: Wang chunsheng  email:2192138785@qq.com
 * @Date:   2021-11-27 18:06:11
 * @Last Modified by:   Wang chunsheng  email:2192138785@qq.com
 * @Last Modified time: 2021-11-27 21:30:05
 */
import Bmap from './Bmap'

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component(Bmap.name, Bmap)
}

export default Bmap
